import { get, isEqual, map, cloneDeep, set } from 'lodash-es';
import * as types from './QuestionnaireBlock.actionTypes';
import { checkConditionsByValues, getCorrectValue } from '../../Utils/utils';

/**
 * set show part by id
 * @param id
 */
const setShowPart = ({ parts, id }) => {
  try {
    const newParts = map(parts, partsItem => {
      if (partsItem.id === id) {
        return { ...partsItem, show: !get(partsItem, 'show') };
      }
      return partsItem;
    });
    return newParts;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowPart: ${e.stack}`);
  }
  return parts;
};

/**
 * set showHelp
 * @param code
 * @param showHelp
 */
const setShowHelperPart = ({ parts, id }) => {
  try {
    const newParts = map(parts, itemPart => {
      if (itemPart.id === id) {
        return {
          ...itemPart,
          showHelp: !get(itemPart, 'showHelp'),
        };
      }
      return itemPart;
    });
    return newParts;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowHelperPart: ${e.stack}`);
  }
  return parts;
};

/**
 * set show group
 * @param {*} param0
 */
const setShowGroup = ({ groups, id }) => {
  try {
    const newGroups = map(groups, groupsItem => {
      if (groupsItem.id === id) {
        return { ...groupsItem, show: !get(groupsItem, 'show') };
      }
      return groupsItem;
    });
    return newGroups;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowGroup: ${e.stack}`);
  }
  return groups;
};

/**
 * set show Tooltip
 * @param id
 * @param showTooltip
 */
const setShowTooltipGroup = ({ groups, id }) => {
  try {
    const newGroups = map(groups, itemGroup => {
      if (itemGroup.id === id) {
        return {
          ...itemGroup,
          showTooltip: !get(itemGroup, 'showTooltip'),
        };
      }
      return itemGroup;
    });
    return newGroups;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowTooltipGroup: ${e.stack}`);
  }
  return groups;
};

/**
 * set showHelp
 * @param code
 * @param showHelp
 */
const setShowHelperQuestion = ({ questions, code }) => {
  try {
    const newQuestions = map(questions, itemQuestion => {
      if (itemQuestion.code === code) {
        return {
          ...itemQuestion,
          showHelp: !get(itemQuestion, 'showHelp'),
        };
      }
      return itemQuestion;
    });
    return newQuestions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowHelperQuestion: ${e.stack}`);
  }
  return questions;
};

/**
 * set Display and Value
 * @param code
 * @param show
 * @param value
 */
// const setShowValueQuestion = ({ questions, code, show, value }) => {
//   try {
//     const newQuestions = map(questions, itemQuestion => {
//       if (itemQuestion.code === code) {
//         return {
//           ...itemQuestion,
//           show,
//           value,
//         };
//       }
//       return itemQuestion;
//     });
//     return newQuestions;
//   } catch (e) {
//     // eslint-disable-next-line no-console
//     console.error(`setShowValueQuestion: ${e.stack}`);
//   }
//   return questions;
// };

const setShowValueQuestions = ({ questions, values, setFieldValue }) => {
  try {
    const newQuestions = map(questions, itemQuestion => {
      const { code, init, show, conditions = [] } = itemQuestion;

      if (conditions.length) {
        const resultShow = checkConditionsByValues({ conditions, values });

        // set display question and reset value
        if (!isEqual(show, resultShow)) {
          const value = getCorrectValue(init);
          setFieldValue(code, value);

          return {
            ...itemQuestion,
            show: resultShow,
            value,
          };
        }
      }

      return itemQuestion;
    });

    return newQuestions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setShowValueQuestions: ${e.stack}`);
  }
  return questions;
};

/**
 * set value question by code
 * @param code
 * @param value
 */
const setValueQuestion = ({ questions, code, value }) => {
  try {
    const newQuestions = map(questions, questionsItem => {
      if (questionsItem.code === code) {
        return {
          ...questionsItem,
          value,
        };
      }
      return questionsItem;
    });
    return newQuestions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`setValueQuestion: ${e.stack}`);
  }
  return questions;
};

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
const reducer = (state, action) => {
  try {
    const { type } = action;
    const newState = cloneDeep(state);

    switch (type) {
      //
      case types.SET_SHOW_PART: {
        const { id } = action;
        const parts = get(state, 'data.parts');
        const newParts = setShowPart({ parts, id });
        set(newState, 'data.parts', newParts);
        break;
      }
      case types.SET_SHOWHELPER_PART: {
        const { id } = action;
        const parts = get(state, 'data.parts');
        const newParts = setShowHelperPart({ parts, id });
        set(newState, 'data.parts', newParts);
        break;
      }
      case types.SET_SHOW_GROUP: {
        const { id } = action;
        const groups = get(state, 'data.groups');
        const newGroups = setShowGroup({ groups, id });
        set(newState, 'data.groups', newGroups);
        break;
      }
      case types.SET_SHOWTOOLTIP_GROUP: {
        const { id } = action;
        const groups = get(state, 'data.groups');
        const newGroups = setShowTooltipGroup({ groups, id });
        set(newState, 'data.groups', newGroups);
        break;
      }
      case types.SET_SHOWHELPER_QUESTION: {
        const { code } = action;
        const questions = get(state, 'data.questions');
        const newQuestions = setShowHelperQuestion({ questions, code });
        set(newState, 'data.questions', newQuestions);
        break;
      }
      // case types.SET_SHOWVALUE_QUESTION: {
      //   const { code, show, value, setFieldValue } = action;
      //   const questions = get(state, 'data.questions');
      //   const newQuestions = setShowValueQuestion({ questions, code, show, value });
      //   setFieldValue(code, value);
      //   set(newState, 'data.questions', newQuestions);
      //   break;
      // }
      case types.SET_SHOWVALUE_QUESTIONS: {
        const { values, setFieldValue } = action;
        const questions = get(state, 'data.questions');
        const newQuestions = setShowValueQuestions({ questions, values, setFieldValue });
        set(newState, 'data.questions', newQuestions);
        break;
      }
      case types.SET_VALUE_QUESTION: {
        const { code, value, setFieldValue } = action;
        const questions = get(state, 'data.questions');
        const newQuestions = setValueQuestion({ questions, code, value, setFieldValue });
        setFieldValue(code, value);
        set(newState, 'data.questions', newQuestions);
        break;
      }
      case types.SET_CODE_FIRST_ERROR: {
        // remove partie by id
        const { codeFirstError } = action;
        set(newState, 'codeFirstError', codeFirstError);
        break;
      }
      case types.UPDATE: {
        const { data } = action;
        return data;
      }
      default:
        // eslint-disable-next-line no-console
        console.error(`Unexpected action`);
        return state;
    }

    // console.log('newState', newState);
    return newState;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`reducer: ${e.stack}`);
  }
  return state;
};

export default reducer;
